export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Мониторинг: Журнал обновления справочников в ОИК",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
